import React, { FC, useContext } from "react";
import { defineMessages, useIntl } from "react-intl";
import { LoadingContext } from "@natera/platform/lib/components/context";

import {
  BillingStatementCard,
  BillingHistoryTemplate,
} from "@app/postBill/components/billingCenterHistory";
import { PostBillHistoryContext } from "@app/provider";
import { GetStatementRequestInput, StatementItem } from "@app/postBill/models";
import { capitalizeFirstLetter } from "@app/utils";
import { useNavigate } from "react-router-dom";
import { routes } from "@app/routing";

const messages = defineMessages({
  billingHistoryStatementsTitle: {
    id: "billingHistoryStatementsTitle",
    defaultMessage: "Statements",
  },
});

const BillingHistoryStatements: FC = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const {
    testCards,
    loadStatementsHistory,
    toggleStatementsSort,
    loadStatementsPage,
  } = useContext(PostBillHistoryContext);

  const onViewStatement = async (
    orderUid: string,
    lineItemUid: string,
    statementUid: string
  ) => {
    const statementData: GetStatementRequestInput = {
      bosOrderUid: orderUid,
      bosLineItemUid: lineItemUid,
      statementUid: statementUid,
    };
    navigate(routes.billingStatementPdf, {
      state: { statementData, from: routes.billingHistoryStatements },
    });
  };

  const renderTestCards = () => {
    return (
      <div>
        {testCards &&
          (testCards as StatementItem[]).map((item: StatementItem) => (
            <BillingStatementCard
              key={item?.statementUid}
              caseNumber={item?.caseNumber}
              testFullName={capitalizeFirstLetter(item?.testType)}
              amountBilled={item?.balance}
              currency={item?.currency}
              dateOfService={item?.dateOfService}
              orderedBy={item?.orderedBy}
              paidStatus={item?.paidStatus}
              onViewStatement={() =>
                onViewStatement(
                  item?.bosOrderUid,
                  item?.bosLineItemUid,
                  item?.statementUid
                )
              }
              hasPdf={item?.hasPDF}
            />
          ))}
      </div>
    );
  };

  return (
    <BillingHistoryTemplate
      title={intl.formatMessage(messages.billingHistoryStatementsTitle)}
      loadHistory={loadStatementsHistory}
      loadPage={loadStatementsPage}
      toggleSort={toggleStatementsSort}
      medium
    >
      {testCards && renderTestCards()}
    </BillingHistoryTemplate>
  );
};

export default BillingHistoryStatements;
